
import Backend from "./Backend";
import createAxiosInstance from "./Axios";
export default new Backend(createAxiosInstance(true))